import AdvertisingMediaAddPage from './AdvertisingMediaAddPage';

export default AdvertisingMediaAddPage;
